import React, { useState } from 'react';
import {
  CircularProgress,
  Grid,
  TableCell,
  TablePagination,
  Tooltip
} from '@material-ui/core';
import { makeStyles, Table, TableFooter, TableRow } from '@material-ui/core';
import TableComponents from 'components/Table/';
import Case from './Case';
import { CustomerType } from 'store/modules/Customers/types';
import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined';
import api from 'api';

const useStyles = makeStyles({
  container: {
    marginTop: '1rem',
    paddingBottom: '36px'
  },
  btn: {
    padding: '0.3rem',
    marginRight: '0.3rem',
    height: '1.5rem'
  },
  iconHolder: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  table: {
    backgroundColor: '#fff'
  },
  pagination: {
    color: '#747474',
    '& p': {
      fontSize: '0.8rem'
    }
  },
  search: {
    marginLeft: '3rem',
    width: '300px'
  },
  spacer: {
    display: 'none'
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center' /* Align items vertically if needed */
  }
});

interface SingleCaseProps {
  id: number;
  name: string;
  pid: string;
  customers: CustomerType[];
  has_inactive_funds: boolean;
}
interface CasesProps {
  casesList: Array<SingleCaseProps>;
  count: number;
  page: number;
  changePage: ({ newPage }: { newPage: number }) => void;
  refreshCaseList: any;
  advisers: any;
}

const Cases = ({
  casesList,
  count,
  page,
  changePage,
  refreshCaseList,
  advisers
}: CasesProps) => {
  const classes = useStyles();
  const [downloadigCases, setDownloadingCases] = useState(false);

  const onChangePage = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ) => {
    changePage({ newPage });
  };
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      className={classes.container}
    >
      <Grid container>
        <Table className={classes.table}>
          <TableComponents.TableHead
            cells={[
              'Case Name',
              'Client Name',
              'Adviser',
              'Case ID',
              '',
              '',
              '',
              '',
              ''
            ]}
          />
          <TableComponents.TableBody>
            {casesList.map(
              ({
                id,
                name,
                customers,
                has_inactive_funds
              }: {
                id: number;
                name: string;
                customers: CustomerType[];
                has_inactive_funds: boolean;
              }) => {
                return (
                  <Case
                    key={id}
                    id={id}
                    name={name}
                    refreshCaseList={refreshCaseList}
                    customers={customers}
                    hasInactiveFunds={has_inactive_funds}
                    advisers={advisers}
                  />
                );
              }
            )}
          </TableComponents.TableBody>
          <TableFooter>
            <TableRow>
              <TableCell colSpan={1000} style={{ padding: '0' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'end'
                  }}
                >
                  {downloadigCases ? (
                    <CircularProgress size="20px" />
                  ) : (
                    <Tooltip title="Download as CSV" arrow>
                      <DownloadForOfflineOutlinedIcon
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setDownloadingCases(true);
                          api.downloadCases().then(response => {
                            const url = window.URL.createObjectURL(
                              new Blob([response.data])
                            );
                            const link = document.createElement('a');
                            link.href = url;
                            const file_name = 'cases.csv';
                            link.setAttribute('download', file_name);
                            document.body.appendChild(link);
                            link.click();
                            setDownloadingCases(false);
                          });
                        }}
                      />
                    </Tooltip>
                  )}
                  <TablePagination
                    className={classes.pagination}
                    count={count}
                    page={page}
                    rowsPerPage={40}
                    onPageChange={onChangePage}
                    rowsPerPageOptions={[40]}
                    classes={{ spacer: classes.spacer }}
                    component="div"
                  />
                </div>
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </Grid>
    </Grid>
  );
};

export default Cases;
